import type {TFunction} from "i18next";

export function relativeDaysLabel(t: TFunction, days: number): string {
    if (days === 0) return t("RELATIVE_TODAY");
    if (days > 0) return t("RELATIVE_IN_DAYS", {count: days});
    return t("RELATIVE_DAYS_AGO", {count: -days});
}
